import { render, staticRenderFns } from "./home-page-video.vue?vue&type=template&id=38c51b03&scoped=true"
import script from "./home-page-video.vue?vue&type=script&lang=js"
export * from "./home-page-video.vue?vue&type=script&lang=js"
import style0 from "./home-page-video.vue?vue&type=style&index=0&id=38c51b03&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c51b03",
  null
  
)

export default component.exports